import { isNotNil } from 'es-toolkit';

import { Nullable } from '@clearverify/types';

import { PeoStaffWhere, UserStatus } from 'src/api';

type PeoStaffTableFilter = {
  status?: Nullable<Nullable<UserStatus>[]>;
};

export const preparePeoStaffFilter = (filter: PeoStaffTableFilter): PeoStaffWhere => {
  const userStatuses = filter.status?.filter(isNotNil);

  const statusFilter =
    userStatuses && userStatuses.length > 0
      ? {
          user: {
            status: {
              in: userStatuses,
            },
          },
        }
      : {};

  return {
    AND: [statusFilter],
  };
};
